import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    NbThemeModule,
    NbCardModule,
    NbButtonModule,
    NbSpinnerModule,
    NbTooltipModule,
    NbSelectModule,
    NbCheckboxModule,
    NbToggleModule,
    NbDatepickerModule,
    NbInputModule,
    NbPopoverModule,
    NbRadioModule,
    NbListModule,
    NbOverlayModule,
    NbDialogModule,
    NbAlertModule,
    NbTabsetModule,
    NbIconModule,
    NbAccordionModule,
} from '@nebular/theme';

import { WaterChartComponent } from '@app/shared/water-chart/component';
import { IrrigationPieChartComponent } from '@app/shared/irrigation-chart/pie-chart.component';
import { GaugeComponent } from '@app/shared/gauge/component';
import { PieChartComponent } from '@app/shared/pie/pie-chart.component';
import { ButtonGroupDirective } from '@app/shared/forms/button-group';
import { NbSliderComponent } from '@app/shared/forms/slider/component';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { LeakChartComponent } from './leak-chart/leak-chart.component';
import { QueryLimitDialogComponent } from './query-limit-dialog/query-limit-dialog.component';
import { SnapshotComponent } from './snapshot/snapshot.component';
import { SnapshotChartComponent } from './snapshot/snapshot-chart/bar-chart.component';
import { InsightPromoComponent } from './insight-promo/insight-promo.component';
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { StaticChartComponent } from './static-chart/static-chart.component';
import { EventsDayChartComponent } from './events-day-chart/events-day-chart.component';

@NgModule({
    imports: [
        CommonModule,
        NbCardModule,
        NbButtonModule,
        ReactiveFormsModule,
        NbSpinnerModule,
        NbSelectModule,
        NbToggleModule,
        NbIconModule,
        NbInputModule,
    ],
    declarations: [
        WaterChartComponent,
        IrrigationPieChartComponent,
        GaugeComponent,
        ButtonGroupDirective,
        NbSliderComponent,
        InfoDialogComponent,
        PieChartComponent,
        LeakChartComponent,
        QueryLimitDialogComponent,
        SnapshotComponent,
        SnapshotChartComponent,
        InsightPromoComponent,
        FeedbackDialogComponent,
        StaticChartComponent,
        EventsDayChartComponent,
    ],
    exports: [
        WaterChartComponent,
        StaticChartComponent,
        IrrigationPieChartComponent,
        PieChartComponent,
        GaugeComponent,
        LeakChartComponent,
        SnapshotComponent,
        SnapshotChartComponent,
        InsightPromoComponent,
        FeedbackDialogComponent,
        EventsDayChartComponent,
        ButtonGroupDirective,
        NbSliderComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NbThemeModule,
        NbCardModule,
        NbSpinnerModule,
        NbButtonModule,
        NbTooltipModule,
        NbInputModule,
        NbSelectModule,
        NbCheckboxModule,
        NbToggleModule,
        NbDatepickerModule,
        NbPopoverModule,
        NbRadioModule,
        NbListModule,
        NbOverlayModule,
        NbDialogModule,
        NbAlertModule,
        NbTabsetModule,
        NbAccordionModule,
    ],
})
export class SharedModule {}
